const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");

const Link = require("../core/view/Link");
const AssetsUtil = require("../core/util/AssetsUtil");
const URLMake = require("../../shared/URLMake");

const styles = require("./styles/SharedSiteTopBar.css");

module.exports = createReactClass({
	displayName: "SharedSiteTopBar",

	propTypes: {
		className: PT.string,
	},

	renderAops: function() {
		return (
			<div className={styles.dropdownAops}>
				<div className={styles.dropdown}>
					<div className={styles.info}>
						<div className={styles.logo}>
							<img src={AssetsUtil.getLogo("aops-online-logo")} />
						</div>
						<div className={styles.snippet}>
							Math texts, online classes, and more
							<br />
							for students in grades 5-12.
						</div>
						<Link
							isNewTab={true}
							className={styles.visit}
							to="//artofproblemsolving.com/"
							isExternal={true}
						>
							Visit AoPS Online <span className={styles.baoFont}>j</span>
						</Link>
					</div>
					<div className={styles.quicknav}>
						<Link
							isNewTab={true}
							isExternal={true}
							to="//artofproblemsolving.com/store"
							className={styles.btn}
						>
							Books for Grades 5-12
						</Link>
						<Link
							isNewTab={true}
							isExternal={true}
							to="//artofproblemsolving.com/school"
							className={styles.btn}
						>
							Online Courses
						</Link>
					</div>
				</div>
			</div>
		);
	},

	renderBao: function() {
		return (
			<div className={styles.dropdownBao}>
				<div className={styles.dropdown}>
					<div className={styles.info}>
						<div className={styles.logo}>
							<img src={AssetsUtil.getLogo("aops-ba")} />
						</div>
						<div className={styles.snippet}>
							Engaging math books and online learning
							<br />
							for students ages 6-13.
						</div>
						<Link
							isNewTab={true}
							className={styles.visit}
							to={URLMake.forOffice()}
							isExternal={true}
						>
							Visit Beast Academy <span className={styles.baoFont}>j</span>
						</Link>
					</div>
					<div className={styles.quicknav}>
						<Link
							isNewTab={true}
							isExternal={true}
							to={URLMake.forBookstore()}
							className={styles.btn}
						>
							Books for Ages 6-13
						</Link>
						<Link
							isNewTab={true}
							isExternal={true}
							to={URLMake.forBAOnline()}
							className={styles.btn}
						>
							Beast Academy Online
						</Link>
					</div>
				</div>
			</div>
		);
	},

	renderAcademy: function() {
		return (
			<div className={styles.dropdownAcademy}>
				<div className={styles.dropdown}>
					<div className={styles.info}>
						<div className={styles.logo}>
							<img src={AssetsUtil.getLogo("aops-academy-logo")} />
						</div>
						<div className={styles.snippet}>
							Small live classes for advanced math
							<br />
							and language arts learners in grades 1-12.
						</div>
						<Link
							isNewTab={true}
							className={styles.visit}
							to={"//aopsacademy.org"}
							isExternal={true}
						>
							Visit AoPS Academy <span className={styles.baoFont}>j</span>
						</Link>
					</div>
					<div className={styles.quicknav}>
						<Link
							isNewTab={true}
							isExternal={true}
							to="//aopsacademy.org/campuses"
							className={styles.btn}
						>
							Find a Physical Campus
						</Link>
						<Link
							isNewTab={true}
							isExternal={true}
							to="//virtual.aopsacademy.org/"
							className={styles.btn}
						>
							Visit the Virtual Campus
						</Link>
					</div>
				</div>
			</div>
		);
	},

	render: function() {
		const spaceMap = [
			["online", "//artofproblemsolving.com/", "AoPS Online", this.renderAops],
			["ba", URLMake.forOffice(), "Beast Academy", this.renderBao],
			["academy", "//aopsacademy.org", "AoPS Academy", this.renderAcademy],
		];
		const active = 1;

		return (
			<div className={styles.main + " " + (this.props.className || "")}>
				<div className={styles.linkContainer}>
					<Link
						to="//artofproblemsolving.com/company"
						className={styles.aops}
						isExternal={true}
					>
						<div className={styles.aopsText}>Art of Problem Solving</div>
					</Link>
					{spaceMap.map(([name, to, heading, content], i) => (
						<div
							className={
								i === active ? styles.selectedLink : styles.nonSelectedLink
							}
							key={name}
						>
							<Link to={to} isExternal={true}>
								<img
									className={styles.icon}
									alt={name.replace("-", " ")}
									src={AssetsUtil.getUmbrellaIcon("icon-" + name)}
								/>
								<span className={styles.title}>{heading}</span>
							</Link>
							{content()}
						</div>
					))}
				</div>
			</div>
		);
	},
});
